export const ResetPassword = {
    default: 1,
    otp: 2,
    confirm: 3
} as const;